var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "stats"
  }, [_c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Accepted "), _c('Tooltip', {
    attrs: {
      "content": "The time when this transaction was accepted by the Explorer Node"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_c('p', {
    staticClass: "date"
  }, [_c('fa', {
    staticClass: "time_icon",
    attrs: {
      "icon": ['far', 'clock']
    }
  }), _c('span', {
    staticClass: "timestamp"
  }, [_vm._v(_vm._s(_vm._f("fromNow")(_vm.date)) + " (" + _vm._s(_vm.date.toLocaleString()) + ")")]), _c('span', {
    staticClass: "status"
  }, [_vm._v("Success")]), _vm.tx.type === 'assetCreation' ? _c('span', {
    staticClass: "status"
  }, [_vm._v("Asset Creation Success")]) : _vm._e()], 1)])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Value "), _c('Tooltip', {
    attrs: {
      "content": "The value transferred in this transaction"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, _vm._l(_vm.outValuesDenominated, function (val, id) {
    return _c('p', {
      key: id,
      staticClass: "asset_value"
    }, [_vm._v(" " + _vm._s(val.amount) + " "), _c('span', {
      staticClass: "unit"
    }, [_vm._v(_vm._s(val.symbol))]), _vm.assetsLoaded ? _c('span', {
      staticClass: "asset_type"
    }, [_vm._v(_vm._s(_vm._f("getAssetType")(_vm.asset(val.assetID))))]) : _vm._e()]);
  }), 0)]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Burned "), _c('Tooltip', {
    attrs: {
      "content": "The fee to process this transaction"
    }
  })], 1), _c('p', {
    staticClass: "meta_value"
  }, [_vm._v(" " + _vm._s(_vm._f("toAVAX")(_vm.tx.txFee)) + " "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("AVAX")])])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Blockchain "), _c('Tooltip', {
    attrs: {
      "content": "The blockchain for this transaction"
    }
  })], 1), _c('div', {
    staticClass: "meta_value"
  }, [_c('span', {
    staticClass: "chain_tag",
    style: {
      backgroundColor: _vm.background
    }
  }, [_vm._v(" " + _vm._s(_vm.chain) + " ")]), _vm.isPChain ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "summary_label"
  }, [_vm._v("Block")]), _c('div', [_vm._v(_vm._s(_vm.tx.txBlockId))])]) : _vm._e()])]), _vm.isMemo ? _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Memo "), _c('Tooltip', {
    attrs: {
      "content": "A 256-byte text field for encoding arbitrary data associated with this transaction"
    }
  })], 1), _c('div', {
    staticClass: "meta_value"
  }, [_c('Memo', {
    attrs: {
      "tx": _vm.tx
    }
  })], 1)]) : _vm._e(), _vm.isStaking ? _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Staking "), _c('Tooltip', {
    attrs: {
      "content": "Validator Rewards for this transaction",
      "color": "#c4c4c4"
    }
  })], 1), _c('div', {
    staticClass: "meta_value"
  }, [_c('StakingSummary', {
    attrs: {
      "tx": _vm.tx
    }
  })], 1)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }